export enum MeliFeatures {
  meliIntegration = "meli_integration",
}
